module.exports = __webpack_public_path__ + "static/scale-model-of-greetings-from-chicago-mural-in-chicago-illinois-135b2b1c84b9b5c31826338a79ab9e3f.png";